import React from 'react'
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'
import { ChevronDownIcon, TrashIcon, XMarkIcon } from '@heroicons/react/24/outline'

import { useSelector } from 'react-redux'
import {
    setFilterDropdown,
    setSelectedOptions,
    setRange,
    setFilterDate,
    setPerPage,
    setCurrentPage,
    handleDeleteAll
} from '../../reducers/contextSlice'
import { useDispatch } from 'react-redux'

/**
 * Modern per-page selector and action buttons (Delete, Reset Filters).
 */
export const PerpageAndDeleteBtn = ({ 
    Icon, 
    delBtn = true, 
    resetFilterBtn = true, 
    name = "10", 
    dropData, 
    deleteUpdateTag, 
    perPageCount = true 
}) => {
    const { filterDropdown, selectedOptions, range, filterDate, perPage, checkedValues } = useSelector((state) => state.context);
    const dispatch = useDispatch();
    
    return (
        <div className='flex flex-wrap gap-2 items-center'>
            {perPageCount && perPage > 0 && (
                <Menu placement='bottom-start'>
                    <MenuHandler>
                        <button className='px-3 py-2 bg-white border border-border rounded-lg text-sm font-medium 
                                         text-text-secondary hover:text-text-primary hover:border-border-strong
                                         flex items-center gap-2 transition-colors'>
                            <span>Show {perPage}</span>
                            <ChevronDownIcon className="h-4 w-4" />
                        </button>
                    </MenuHandler>
                    <MenuList className='min-w-[100px] p-1 border-border shadow-md'>
                        {[5, 10, 15, 20, 25]?.map((_ele) => (
                            <MenuItem 
                                key={_ele} 
                                onClick={() => { 
                                    dispatch(setCurrentPage(1)); 
                                    dispatch(setPerPage(_ele)); 
                                }} 
                                className={`
                                    px-3 py-2 text-sm rounded-md transition-colors
                                    ${perPage == _ele 
                                        ? 'bg-primary-500 text-white hover:bg-primary-600' 
                                        : 'hover:bg-background-hover'
                                    }
                                `}
                            >
                                {_ele}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Menu>
            )}

            {delBtn && checkedValues.length > 0 && (
                <button 
                    className='px-3 py-2 bg-error-DEFAULT hover:bg-error-dark text-white rounded-lg 
                             text-sm font-medium transition-colors shadow-sm hover:shadow-md
                             flex items-center gap-2 whitespace-nowrap'
                    onClick={() => dispatch(handleDeleteAll(deleteUpdateTag))} 
                    disabled={checkedValues?.length === 0}
                >
                    <TrashIcon className="h-4 w-4" />
                    Delete ({checkedValues.length})
                </button>
            )}

            {resetFilterBtn && (Object.keys(filterDropdown).length > 0 || filterDate) && (
                <button 
                    className='px-3 py-2 bg-white border border-border hover:border-border-strong rounded-lg 
                             text-sm font-medium text-text-secondary hover:text-text-primary
                             transition-colors flex items-center gap-2 whitespace-nowrap'
                    onClick={() => { 
                        dispatch(setFilterDropdown({})); 
                        dispatch(setSelectedOptions([])); 
                        dispatch(setRange({})); 
                        dispatch(setFilterDate("")); 
                    }} 
                    disabled={!Object.keys(filterDropdown).length}
                >
                    <XMarkIcon className="h-4 w-4" />
                    Reset Filters
                </button>
            )}
        </div>
    )
}

export default PerpageAndDeleteBtn
